import { graphql } from '@apollo/react-hoc';

import { SUMMARY_COLUMNS } from 'components/Metrics/constants/columns';
import Sources from './Sources.graphql';
import DeleteSource from './DeleteSource.graphql';
import UpdateSource from './UpdateSource.graphql';
import CreateSource from './CreateSource.graphql';
import Source from './Source.graphql';
import Production from './Production.graphql';

export const SourcesQuery = Sources;
export const DeleteSourceMutation = DeleteSource;
export const UpdateSourceMutation = UpdateSource;
export const CreateSourceMutation = CreateSource;
export const SourceQuery = Source;
export const ProductionQuery = Production;

const withProductionRead = graphql(ProductionQuery, {
  skip: ({ productionId }) => !productionId,
  options: ({ productionId }) => ({
    variables: { id: parseInt(productionId, 10) },
  }),
  props: ({ data: { production, loading } }) => ({ production, loading }),
});

const withSourceRead = graphql(SourceQuery, {
  skip: ({ id }) => !id,
  options: ({ id }) => ({
    variables: {
      id,
      metricConfig: [{ allMetrics: true }],
      columns: SUMMARY_COLUMNS,
      countryBreakdown: true,
    },
  }),
  props: ({ data: { source, loading, refetch } }) => ({
    source,
    loading,
    refetch,
  }),
});

const withSourceCreate = graphql(CreateSourceMutation, { name: 'create' });
const withSourceUpdate = graphql(UpdateSourceMutation, { name: 'update' });

export {
  withProductionRead,
  withSourceRead,
  withSourceCreate,
  withSourceUpdate,
};
